export const getQSParam=(name)=>{
	let searchStr=window.location.search;
	if(searchStr===undefined)
		return;
	if(searchStr.substring(0,1)==='?')
		searchStr=searchStr.substring(1);
	return searchStr
		.split('&')
		.map(e=>{
			let key=e.split('=');
			if(key[0].toUpperCase()===name.toUpperCase())
				return key[1];
			return undefined;
		})
		.filter(item=>item!==undefined)
		.join('');
}